import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ContextFactory } from '@shared/factories/context/context.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { TooltipModule } from 'primeng/tooltip';
import { AfSiteTermsDirective } from '../../../shared/modules/translate/directive/af-SiteTerms.directive';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';

@Component({
    selector: 'help-modal',
    templateUrl: './help-modal.component.html',
    standalone: true,
    imports: [AfTranslateDirective, AfSiteTermsDirective, TooltipModule]
})
export class HelpModalComponent implements OnInit {
  skin:string = this.globalCfg.skin;

  constructor(
    private globalCfg: GlobalCfgFactory,
    private commonUtilsService:CommonUtilsService,
    private context:ContextFactory,
    private dialogRef: DynamicDialogRef<HelpModalComponent>) { }

  ngOnInit(): void {
    if(this.skin === 'dark-blue'){
      let src = window.location.href.indexOf('lefebvre') !== -1? "https://atenea.lefebvre.es/api/chat/script": "https://led-dev-atenea-dev.eu.els.local/api/chat/script"
      $('body').append( '<script id="lf-chatservice-lefebvre" data-o="centinela" data-u="'+this.context.user.externalId+'" data-s="Chat_SAC_GENERAL" src="'+src+'" data-hb="0" data-hm="0" data-align="br"></script>');
    }
  }

  initChat() {
    setTimeout(()=>{
      let chatBubble: any = $('#chatBubble');
      chatBubble.click();
    })
    this.handleDismiss()
  }

  openURL(opcion:number){
    let url = '';
    let language = this.commonUtilsService.getLanguage().substring(0,2);
    switch(opcion){
      case 1:
        switch(this.skin){
          case 'steel-blue':
            switch(language){
              case 'nl':
                url = 'https://www.gocomply.be/nl-support';
                break;
              case 'fr':
                url ='https://www.gocomply.be/fr-support';
                break;
              default:
                url ='https://www.gocomply.be/en-support';
                break;
            }
            break;
          case 'uk-steel-blue':
            url = 'https://download.lefebvre-sarrut.be/dms?id_=93a438d2-299b-49c6-bea7-eaac7d3c1546';
            break;
          default:
            url = 'https://centrodeayuda.lefebvre.es/preguntas-frecuentes/?idEntrada=' + this.context.user.externalAccessId;
            break;
        }
        break;
      case 2:
        url = 'https://centrodeayuda.lefebvre.es/cursos/?idEntrada=' + this.context.user.externalAccessId;
        break;
      case 3:
        url = 'https://centrodeayuda.lefebvre.es/videos/?idEntrada=' + this.context.user.externalAccessId;
        break;
      case 4:
        switch(this.skin){
          case 'steel-blue':
            switch(language){
              case 'nl':
                url = 'https://larcier.atlassian.net/wiki/spaces/GOC/pages/1702199462/Handleiding+GoComply';
                break;
              case 'fr':
                url ='https://larcier.atlassian.net/wiki/spaces/GOC/pages/1702199455/Manuel+GoComply';
                break;
              default:
                url='https://larcier.atlassian.net/wiki/spaces/GOC/pages/1759346810/Manual+GoComply';
                break;
            }
            break;
          case 'uk-steel-blue':
            url = 'https://download.lefebvre-sarrut.be/dms?id_=6bb90221-b901-4a38-81dc-7f43a3da4738';
            break;
          case 'gm-law':
            url = 'https://swift.it-mil2.entercloudsuite.com/v1/KEY_44f2d0920f254271a50851d48ed28f01/whistleblowing/Manuale_WB.html';
            break;
          default:
            url ='https://centrodeayuda.lefebvre.es/manuales/?idEntrada=' + this.context.user.externalAccessId;
            break;
        }
        break;
    }
    window.open(url);
  }

  handleDismiss(){
    this.dialogRef.close({result:'cancel'});
  }
}
